import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const GraficoBarrasMes = ({ dados }) => {
    const labels = dados.map(item => item.MES);

    const datasets = [
        {
            label: 'Automática',
            data: dados.map(item => (item.ENTRADA_AUTOMATICA * 100) /
                (item.ENTRADA_AUTOMATICA + item.ENTRADA_AUTOMATICA_ALT + item.ENTRADA_MANUAL)),
            backgroundColor: '#4CAF50'
        }//,
        // {
        //     label: 'Auto. c/ Alteração',
        //     data: dados.map(item => (item.ENTRADA_AUTOMATICA_ALT * 100) /
        //         (item.ENTRADA_AUTOMATICA + item.ENTRADA_AUTOMATICA_ALT + item.ENTRADA_MANUAL)),
        //     backgroundColor: '#8BC34A'
        // },
        // {
        //     label: 'Manual',
        //     data: dados.map(item => (item.ENTRADA_MANUAL * 100) /
        //         (item.ENTRADA_AUTOMATICA + item.ENTRADA_AUTOMATICA_ALT + item.ENTRADA_MANUAL)),
        //     backgroundColor: '#BDBDBD'
        // }
    ];

    const data = { labels, datasets };

    const options = {
        plugins: {
            title: {
                display: true,
                text: 'Distribuição por Mês (%)'
            },
            legend: {
                position: 'bottom'
            },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.dataset.label}: ${context.parsed.y.toFixed(2)}%`
                }
            },
            datalabels: {
                anchor: 'center',
                align: 'center',
                color: '#fff',
                formatter: (value) => `${value.toFixed(1)}%`,
                font: {
                    weight: 'bold'
                }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Mês'
                }
            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Percentual (%)'
                },
                max: 100,
                ticks: {
                    callback: (value) => `${value}%`
                },
                grid: {
                    display: false
                }
            }
        }
    };

    return (
        <div style={{ width: '100%', height: 300 }}>
            <Bar data={data} options={options} plugins={[ChartDataLabels]} />
        </div>
    );
};

export default GraficoBarrasMes;
